const angular = require('angular');

const RecommendationProductsService = require('./recommendation-products.service');

const { recommendationProductsControllerComponentDefinition } = require('./recommendation-products.component');

angular.module('wowApp.shop')
    .component('wowRecommendationProducts', recommendationProductsControllerComponentDefinition)
    .service('RecommendationProductsService', ['Restangular', RecommendationProductsService]);



// WEBPACK FOOTER //
// ./src/shop/recommendation/index.js